import { TiDocumentText } from 'react-icons/ti';

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const documents = {
  id: 'documents',
  title: '',
  type: 'group',
  children: [
    {
      id: 'documents-management',
      title: 'Documents',
      type: 'item',
      url: '/documents',
      icon: TiDocumentText,
      allowedRoles: ['admin', 'superAdmin', 'complianceOfficer'],
      breadcrumbs: false
    }
  ]
};

export default documents;
